/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import { Grid, makeStyles, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction, FormControl, Select, Tooltip, MenuItem, InputLabel, Paper } from "@material-ui/core";
import { Edit, Delete, LockOpen, Person, Add, Autorenew } from "@material-ui/icons";
import { dateFormat } from "../utils";
import MuiDialog from "../Dialog";
import EditUser from "./EditUser";
import Actions from "../../../fluid/Actions/ActionFactory";
import SnackBar from "../../Snackbar/index";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";

import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  container: {
    height: "calc(100vh - 95px)",
    overflow: "hidden",
  },
  headerSec: {
    width: "100%",
    height: "40%",
  },
  boxWrapper: {
    height: "58%",
  },
  filedBox: {
    width: "49%",
    marginTop: "20px",
  },
}));

export const BoxContainer = ({ title, dataList }) => {
  return (
    <div
      style={{
        height: "100%",
        background: "#f6f6f6",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #00000029",
          background: "#FFFFFF",
          fontWeight: "bold",
          padding: "10px",
        }}
      >
        <span style={{ color: "#222222" }}>{title}</span>
        {title === "Users" ? (
          <span style={{ color: "#707070" }}>
            {"  (" + dataList.length + ")"}
          </span>
        ) : (
          ""
        )}
      </div>
      <div style={{ overflow: "auto", minHeight: "75%", maxHeight: "455px" }}>
        {dataList?.map((item, index) => (
          <div
            style={{
              padding: "15px",
              margin: "10px",
              background: "#FFFFFF",
              boxShadow: "0px 3px 6px #00000029",
              borderRadius: "5px",
            }}
          >
            <div style={{ color: "#222222" }}>{item?.name}</div>
            {title === "Users" ? (
              <div style={{ color: "#707070" }}>{item?.email}</div>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const ViewUser = ({
  selectedData,
  isTableUpdated,
  setIsTableUpdated,
  setdeleted,
}) => {
  const classes = useStyles();
  console.log("child", selectedData);
  const data = selectedData;
  const [newPassword, setNewPassword] = useState("");
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isUserDelete, setIsUserDelete] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false)
  const [isEditUser, setIsEditUser] = useState(false);
  const [isEdited, setisEdited] = useState(false);
  const [isViewEnable, setIsViewEnable] = useState(true);
  const [success, setsuccess] = useState(false);
  const [error, seterror] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  const [message, setmessage] = useState("");
  const [rolesList, getRolesList] = useState([])
  const [selectedRole, setSelectedRole] = useState(null)
  const [roleBindingList, getRoleBindingList] = useState([])
  const [roleBindedData, setRoleBindingList] = useState([])
  const [rolesList_err, getRolesErr] = useState("")

  useEffect(() => {
    getRolesErr("")
    Actions('http_request', {
      url: "/sainapse/role",
      method : "get",
      data : {}
    }).then(res => {
      getRolesErr("")
      getRolesList(res.data.result.map(role => {
        return {
          name : role.name,
          group_name : role.group_name
        }
      }))
    }).catch(err => {
      getRolesList([])
      getRolesErr(err.message)
    })
  },[]);

  useEffect(() => {
    getRolesErr("")
    Actions('http_request', {
      url: "/sainapse/role_binding/user/" + data.email,
      method : "get",
      data : {}
    }).then(res => {
      getRolesErr("")
      getRoleBindingList(res.data.result !== null ? res.data.result : []);
    }).catch(err => {
      getRoleBindingList([])
      getRolesErr(err.message)
    })
  },[selectedData]);

  // useEffect(() => {
  //   const params = {
  //     group_name: data?.group_name,
  //     role: {
  //         group_name: selectedData.group_name,
  //         name: selectedData.name,
  //     },
  //     user: {
  //         email: selectedData.email,
  //     },
  //   };
  //   getRolesErr("")
  //   Actions('http_request', {
  //     url: "/sainapse/role_binding",
  //     method : "post",
  //     data : [params],
  //   }).then(res => {
  //     getRolesErr("")
  //     setRoleBindingList(res.data.result);
  //     console.log("set roles in user" + res.data.result);
  //   }).catch(err => {
  //     setRoleBindingList([])
  //     getRolesErr(err.message)
  //   })
  // },[]);

  const setRoleBinding = () => {
    let role_binding = {
      role: {
          group_name: selectedRole.group_name,
          name: selectedRole.name,
      },
      user: {
          email: data.email,
      }
    }

    Actions('http_request', {
      url : "/sainapse/role_binding",
      method : "post",
      data : [role_binding]
    }).then(res => {
      getRolesErr("")
      Actions('http_request', {
        url: "/sainapse/role_binding/user/" + data.email,
        method : "get",
        data : {}
      }).then(res => {
        getRolesErr("")
        getRoleBindingList(res.data.result !== null ? res.data.result : []);
        setSelectedRole(null)
      }).catch(err => {
        getRoleBindingList([]);
        getRolesErr(err.message);
      })
    }).catch(err => {
      //getRoleBindingList([]);
      setSelectedRole(null)
      getRolesErr(err.message);
      seterror(true);
      seterrmsg(err);
  })
}

  const deleteRoleBinding = (role) => {
    let role_binding = {
      role: {
          group_name: role.group_name,
          name: role.name,
      },
      user: {
          email: data.email,
      }
    }

    Actions('http_request', {
      url : "/sainapse/role_binding",
      method : "delete",
      data : [role_binding]
    }).then(res => {
      getRolesErr("")
      Actions('http_request', {
        url: "/sainapse/role_binding/user/" + data.email,
        method : "get",
        data : {}
      }).then(res => {
        getRolesErr("")
        getRoleBindingList(res.data.result !== null ? res.data.result : []);
        setSelectedRole(null)
      }).catch(err => {
        getRoleBindingList([])
        getRolesErr(err.message)
      })
    })
  }

  useEffect(() => {
    setIsEditUser(false);
  }, [selectedData]);
  useEffect(() => {
    if (isReset === true && newPassword.length) {
      Actions("http_request", {
        url: "/sainapse/reset_password",
        method: "post",
        params: {
          email: data.email,
        },
        data: newPassword,
        headers: { "Content-type": "application/json" },
      })
        .then((res) => {
          console.log("res..1", res.data);
          setIsTableUpdated(true);
          setsuccess(true);
          setmessage("Password reseted successfully");
          setNewPassword("");
          setIsReset(false);
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
        });
    }
  }, [isPasswordReset]);

  useEffect(() => {
    if (!!data && isDeleted) {
      Actions("http_request", {
        url: "/sainapse/user/" + data.email,
        method: "delete",
      })
        .then((res) => {
          console.log("res..1", res.data);
          setIsDeleted(!isDeleted);
          setIsTableUpdated(true);
          setIsViewEnable(false);
          setdeleted(true);
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
        });
    }
  }, [isDeleted]);

  useEffect(() => {
    if (!!data && isUnlocked) {
      Actions("http_request", {
        url: "/sainapse/user/unlock",
        method: "post",
        params : {
          email : data.email
        }
      })
        .then((res) => {
          console.log("res..1", res.data);
          setIsUnlocked(!isUnlocked);
          setIsTableUpdated(true);
          setIsViewEnable(false);
          setdeleted(true);
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
        });
    }
  }, [isUnlocked]);

  const handleResetPassword = () => {
    setIsPasswordReset(true);
  };
  const handleDeleteUser = () => {
    setIsUserDelete(true);
  };

  const handleUnlockUser = () => {
    setIsUnlocked(true);
  };

  const handleEditUser = () => {
    setIsEditUser(true);
  };
  const onClose = () => {
    setisEdited(false);
  };
  const onClosesuccess = () => {
    setsuccess(false);
    setmessage("");
  };
  const onCloseerror = () => {
    seterror(false);
    seterrmsg(null);
  };

  return (
    <>
      {isEditUser ? (
        <EditUser
          prevData={data}
          setIsEditUser={setIsEditUser}
          setisEdited={setisEdited}
          setIsTableUpdated={setIsTableUpdated}
        />
      ) : isViewEnable ? (
        <Grid data-testid="view" container className={classes.container}>
          <Grid item className={classes.headerSec}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "30%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "5px",
                    marginRight: "10px",
                  }}
                >
                  <Person
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "#00000059",
                    }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      color: "#222222",
                      fontSize: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    {data?.name ? data.name : "Unknown"} <br />{" "}
                    <span
                      style={{
                        color: "#707070",
                        fontWeight: "normal",
                        fontSize: "17px",
                      }}
                    >
                      {data?.email ? data.email : "-"}
                    </span>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "37%",
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "10px",
                  marginRight : '20px'
                }}
              >
                {
                  data.is_locked ? 
                  <Tooltip title = "Unlock User">
                    <IconButton
                    fontSize="small"
                    disableRipple={true}
                    style={{
                      display: "block",
                      color: "#FF0000",
                      cursor: "pointer",
                      width: "33.3%",
                      background: "none",
                    }}
                    onClick = {handleUnlockUser}
                    ><LockOpen/>
                    </IconButton> 
                  </Tooltip> : null
                }
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/reset_password",
                        method : "POST",
                        operands : []
                      }}
                  >
                  <Tooltip title = "Reset Password">
                    <IconButton
                      fontSize="small"
                      disableRipple={true}
                      style={{
                        display: "block",
                        color: "#FFB846",
                        cursor: "pointer",
                        width: "33.3%",
                        background: "none",
                      }}
                      onClick={handleResetPassword}
                    >
                      <Autorenew />
                    </IconButton>
                  </Tooltip>
                </SecureWrapper>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/user/{email}",
                        method : "PUT",
                        operands : [
                          {
                            attrName: "email",
                            value : data.email
                      }]
                      }}
                  >
                  <Tooltip title = "Edit">
                    <IconButton
                      fontSize="small"
                      disableRipple={true}
                      style={{
                        display: "block",
                        color: "#3683F7",
                        cursor: "pointer",
                        width: "33.3%",
                        background: "none",
                      }}
                      onClick={handleEditUser}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                </SecureWrapper>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/user/{email}",
                        method : "DELETE",
                        operands : [
                          {
                            attrName: "email",
                            value : data.email
                      }]
                      }}
                  >
                  <Tooltip title = "Delete">
                    <IconButton
                      fontSize="small"
                      disableRipple={true}
                      style={{
                        display: "block",
                        color: "#FF0000",
                        cursor: "pointer",
                        width: "33.3%",
                        background: "none",
                      }}
                      onClick={handleDeleteUser}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </SecureWrapper>
              </div>
            </div>
            <div
              style={{
                boxShadow: "0px 3px 6px #00000029",
                bordeRadius: "5px",
                height: "70%",
              }}
            >
              <div
                style={{
                  background: "#FFFFFF",
                  borderBottom: "1px solid #00000029",
                  padding: "20px",
                  color: "#707070",
                  height: "70%",
                  overflow: "auto",
                }}
              >
                <p>{data?.description ? data.description : "No Description"}</p>
              </div>
              <div
                style={{
                  display: "flex",
                  background: "#FFFFFF",
                  padding: "20px",
                  height: "30%",
                }}
              >
                <div style={{ paddingRight: "60px" }}>
                  <p style={{ color: "#707070" }}>
                    Active Since <br />{" "}
                    <span style={{ color: "#3682F7" }}>
                      {dateFormat(data?.created_date)}
                    </span>
                  </p>
                </div>
                <div>
                  <p style={{ color: "#707070" }}>
                    Last Updated <br />
                    <span style={{ color: "#3682F7" }}>
                      {dateFormat(data?.updated_date)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </Grid>
          <Grid
            container
            className={classes.boxWrapper}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid item className={classes.filedBox}>
              <BoxContainer title="Groups" dataList={data?.groups} />
            </Grid>
            <Grid item className={classes.filedBox}>
              {/* <BoxContainer title="Roles" dataList={roleBindingList}>
              <ListItem 
                    key = {0} 
                    dense 
                    button 
                >
                    <ListItemText  primary = {roleBindingList}/>
                </ListItem>
              </BoxContainer> */}
              <div
                style={{
                  height: "100%",
                  background: "#f6f6f6",
                  boxShadow: "0px 3px 6px #00000029",
                  borderRadius: "5px",
                }}
              >
                <div
                  style={{
                    borderBottom: "1px solid #00000029",
                    background: "#FFFFFF",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  <span style={{ color: "#222222" }}>Roles</span>
                </div>
                <div style={{ overflow: "auto", minHeight: "75%", maxHeight: "455px", padding : '10px' }}>
                  <div style = {{width : '100%', display : "flex", flexDirection : 'row', alignItems : 'center'}}> 
                    {console.log("Selected Role : ", selectedRole)}
                    <FormControl 
                      style={{ flexGrow : 1}}
                      variant = 'standard' 
                      size = 'small'
                    >
                      <InputLabel>Select Role</InputLabel>
                      <Select
                        displayEmpty
                        value = {selectedRole}
                        renderValue = {() => selectedRole !== null ? selectedRole.group_name + " / " + selectedRole.name : null}
                        onChange = {(event) => {
                          console.log("Setting Selected Role : ", event.target.value)
                          setSelectedRole(event.target.value)
                        }}
                      >
                        {rolesList.map((role, i) => {
                          return (
                            <MenuItem key = {i} value = {role}>{role.group_name + " / " + role.name}</MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role_binding",
                        method : "POST",
                        operands : []
                      }}
                      >
                      <IconButton 
                        color = 'primary' 
                        disabled = {selectedRole === null}
                        onClick = {setRoleBinding}
                      >
                        <Add/>
                      </IconButton>
                    </SecureWrapper>
                  </div>
                  <List>
                      {console.log("roleBindingList is", roleBindingList)}
                      {roleBindingList.map((role, i) => {
                        return (
                          <ListItem
                            ContainerComponent = {Paper}
                            ContainerProps = {{
                              style : {marginTop : '5px'}
                            }}
                          >
                            <ListItemText
                              primary = {role.role.group_name + " / " + role.role.name}
                            />
                            <ListItemSecondaryAction>
                              <SecureWrapper
                                access_object = {{
                                  operation : "/sainapse/role_binding",
                                  method : "DELETE",
                                  operands : []
                                }}
                                >
                                <IconButton color = 'secondary' size = 'small'>
                                  <Delete fontSize = 'inherit' onClick = {() => deleteRoleBinding(role.role)}/>
                                </IconButton>
                              </SecureWrapper>
                            </ListItemSecondaryAction>
                          </ListItem>
                        )
                      })}
                  </List>
                </div>
              </div>
            </Grid>
          </Grid>
          {isUserDelete && (
            <MuiDialog
              menu="users"
              data={data}
              open={isUserDelete}
              type="delete"
              title="Delete User"
              onClose={setIsUserDelete}
              onSuccess={setIsDeleted}
            />
          )}
          {isPasswordReset && (
            <MuiDialog
              menu="users"
              data={data}
              open={isPasswordReset}
              type="reset"
              title="Resetting Password"
              newPassword={newPassword}
              setNewPassword={setNewPassword}
              onClose={setIsPasswordReset}
              setIsReset={setIsReset}
            />
          )}
        </Grid>
      ) : null}
      {isEdited && (
        <SnackBar
          openDialog={isEdited}
          message={"User has been Updated successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {success && (
        <SnackBar
          openDialog={success}
          message={message}
          onclose={onClosesuccess}
          severity={"success"}
        />
      )}
      {error && (
        <ErrorMessageAlert
          open={error}
          handleClose={onCloseerror}
          errorInfo={errmsg}
        />
      )}
    </>
  );
};

export default ViewUser;
